<template>
  <div class="container">
    <form novalidate @submit.prevent="submitEditPincode">
      <BreadcrumbGroup v-if="!isAuWallet()" :items="breadcrumbItems" />

      <HeadingOne class="-margin-md">暗証番号の再設定</HeadingOne>

      <ErrorsAlert
        :errors="errors"
        :column-only="true"
        :items="inputItemsMb"
      ></ErrorsAlert>

      <WizardGroup class="-margin-md">
        <MainWizard :active-index="0" type="userpassword"></MainWizard>
      </WizardGroup>

      <p>
        お借り入れやご返済、お客さま情報変更時にご入力いただく暗証番号はこちらからご変更いただけます。<br />
        暗証番号をお忘れのお客さまも以下より再設定してください。
      </p>
      <ListGroup class="-note">
        <ListItem class="-note"
          >再設定の完了後は、今までの暗証番号は無効となりますのでご注意ください。</ListItem
        >
      </ListGroup>

      <section>
        <TableBox>
          <TableBody>
            <TableRow>
              <TableHeader class="-entry">
                新しい暗証番号<small class="moji">【半角数字4文字】</small>
                <TooltipsItem>
                  ・生年月日、電話番号、「0000」などの4桁の同じ数字はご利用いただけません。
                </TooltipsItem>
              </TableHeader>
              <TableData :has-error="errors['new_pincode']">
                <InputGroup :errors="errors" :prop-names="['new_pincode']">
                  <InputgroupAppend>
                    <InputItem
                      id="pincode"
                      v-model="pincode.pincode"
                      class="-sm"
                      type="password"
                      :maxlength="4"
                    ></InputItem>
                  </InputgroupAppend>
                </InputGroup>
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader class="-entry"
                >新しい暗証番号<small
                  >（確認用）<small class="moji"
                    >【半角数字4文字】</small
                  ></small
                ></TableHeader
              >
              <TableData :has-error="errors['new_pincode_confirmation']">
                <InputGroup
                  :errors="errors"
                  :prop-names="['new_pincode_confirmation']"
                >
                  <InputgroupAppend>
                    <InputItem
                      id="pincode_confirmation"
                      v-model="pincode.pincode_confirmation"
                      class="-sm"
                      type="password"
                      :maxlength="4"
                    ></InputItem>
                  </InputgroupAppend>
                </InputGroup>
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </section>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" @click.prevent="submitEditPincode">
          再設定する
        </BtnMain>
      </BtngroupSingle>
    </form>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import { validatePincodeLambdaInvoke } from "@/utils/LambdaHelper";
import { inputItemsMb } from "@/constants/constant";
import { isAuWallet } from "@/utils/UserAgent";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import TooltipsItem from "@/components/tooltip/TooltipsItem";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import HeadingOne from "@/components/heading/HeadingOne";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import InputGroup from "@/components/input/InputGroup";
import InputItem from "@/components/input/InputItem";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb032",
  components: {
    InputgroupAppend,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    InputItem,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    WizardGroup,
    MainWizard,
    HeadingOne,
    TooltipsItem,
    ErrorsAlert,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "暗証番号の再設定",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "暗証番号の再設定",
          active: true,
        },
      ],
      errors: {},
      pincode: {
        pincode: "",
        pincode_confirmation: "",
      },
      isDisabled: false,
      inputItemsMb: inputItemsMb,
    };
  },
  methods: {
    submitEditPincode: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            validatePincodeLambdaInvoke(this.pincode)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "mb031" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    isAuWallet: function () {
      return isAuWallet();
    },
  },
};
</script>

<style scoped></style>
